var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbcdBikeInsuranceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.000244141,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F1F3F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.42 13.9998L17.41 9.99976H13V11.9998H16.59L18.59 13.9998H10.5C8 13.9998 6 15.9998 6 18.4998C6 20.9998 8 22.9998 10.5 22.9998C12.72 22.9998 14.56 21.3798 14.92 19.2698L17.04 17.9998C17 18.1698 17 18.3298 17 18.4998C17 20.9998 19 22.9998 21.5 22.9998C24 22.9998 26 20.9998 26 18.4998C26 15.9998 24 13.9998 21.5 13.9998H21.42ZM12.84 19.2598C12.5 20.2698 11.58 20.9998 10.47 20.9998C9.09 20.9998 7.97 19.8798 7.97 18.4998C7.97 17.1198 9.09 15.9998 10.47 15.9998C11.59 15.9998 12.5 16.7398 12.84 17.7498H10V19.2498L12.84 19.2598ZM21.47 20.9998C20.09 20.9998 18.97 19.8798 18.97 18.4998C18.97 17.1198 20.09 15.9998 21.47 15.9998C22.133 15.9998 22.7689 16.2631 23.2378 16.732C23.7066 17.2008 23.97 17.8367 23.97 18.4998C23.97 19.1628 23.7066 19.7987 23.2378 20.2675C22.7689 20.7364 22.133 20.9998 21.47 20.9998Z",
    fill: "#767D93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbcdBikeInsuranceIcon);
export default __webpack_public_path__ + "static/media/abcd-bike-insurance-icon.e1ce5220352cd22d35fd8e15243ff7ee.svg";
export { ForwardRef as ReactComponent };